import { useState, useLayoutEffect } from 'react';

/**
 * Returns true when the ref'd element's text is clipped by an ellipsis
 * (scrollWidth > clientWidth). Re-measures on mount, when `dep` (the text)
 * changes, and on window resize (the element width is fluid).
 */
const useIsTextTruncated = (ref, dep) => {
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const measure = () => {
      const el = ref.current;
      if (el) {
        setIsTruncated(el.scrollWidth > el.clientWidth);
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [ref, dep]);

  return isTruncated;
};

export default useIsTextTruncated;
